import axiosInstance from '../helpers/axiosInstance'

// Who receives the document of a warehouse's dispatches, per carrier (platform
// ShippingDispatchRecipientsController). carrier_name null = every carrier.
const recipientsUrl = warehouseId => `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/dispatch-document-recipients`

export const fetchDispatchDocumentRecipients = async warehouseId => {
  const res = await axiosInstance.get(recipientsUrl(warehouseId))
  return res.data
}

export const createDispatchDocumentRecipient = async (warehouseId, recipient) => {
  const res = await axiosInstance.post(recipientsUrl(warehouseId), recipient)
  return res.data
}

export const updateDispatchDocumentRecipient = async (warehouseId, id, recipient) => {
  const res = await axiosInstance.put(`${recipientsUrl(warehouseId)}/${id}`, recipient)
  return res.data
}

export const deleteDispatchDocumentRecipient = async (warehouseId, id) => {
  await axiosInstance.delete(`${recipientsUrl(warehouseId)}/${id}`)
}

export const fetchDispatchDocumentRecipientsHistory = async (warehouseId, params = {}) => {
  const res = await axiosInstance.get(`${recipientsUrl(warehouseId)}/history`, { params })
  return res.data
}
